angular.module('impactx.rfxsupplier').component('ixRfxSupplierCustomerItems', {
        bindings: {
            customerItems: '<',
            smartFormPolicies: '<',
            readOnly: '<',
            onItemAdded: '&',
            isClosed: '<',
            trns: '<'
        },
        controller: 'RFXSupplierCustomerItemsCtrl',
        templateUrl: 'modules/rfxsupplier/templates/rfx-supplier-customer-items.html'
    }
);